import { __assign } from "tslib";
import create from 'zustand';
export var useEdgeworthDocumentsStore = create(function (set, get) { return ({
    documents: [],
    documentsMap: new Map(),
    mergeDocumentsIntoMap: function (newDocuments) {
        if (!newDocuments.length) {
            return;
        }
        // Update map with new documents
        var documentsMap = get().documentsMap;
        newDocuments.forEach(function (newDocument) {
            if (newDocument.isDeleted) {
                // Delete documents if necessary
                if (documentsMap.has(newDocument.id)) {
                    documentsMap.delete(newDocument.id);
                }
            }
            else {
                documentsMap.set(newDocument.id, newDocument);
            }
        });
        set({
            documents: Array.from(documentsMap.values()),
        });
    },
    updateDocument: function (id, newProps) {
        var documentsMap = get().documentsMap;
        if (!documentsMap.has(id)) {
            return;
        }
        var newDocument = __assign(__assign({}, documentsMap.get(id)), newProps);
        documentsMap.set(id, newDocument);
        set({
            documents: Array.from(documentsMap.values()),
        });
    },
}); });
export var useEdgeworthStoreDocumentUpdater = function () {
    return useEdgeworthDocumentsStore().updateDocument;
};
export var useEdgeworthStoreDocumentUpdaterUnreactive = function () {
    return useEdgeworthDocumentsStore.getState().updateDocument;
};
export var getEdgeworthDocumentsUnreactive = function () {
    return useEdgeworthDocumentsStore.getState().documents;
};
//# sourceMappingURL=useEdgeworthDocumentsStore.js.map